module.exports = __webpack_public_path__ + "media/images/app_store-4bf1177a4f46525dd0b5228f82bd3cbc.svg";